'use strict'
import {
    RECEIVE_INSTALLATION,
    RECEIVE_INSTALLATIONS,
    RECEIVE_ALL_VARIOUS_MATERIELS,
    RECEIVE_VARIOUS_MAT_SITUATIONS,
    RECEIVE_VARIOUS_MAT_TYPES,
    RECEIVE_ALL_INSTALLATIONS_GEO,
    RESET_INSTALLATION,
    RECEIVE_MAP_SITUATIONS_STATION,
    RECEIVE_MAP_SITUATIONS_STATION_LAST,
    RECEIVE_LINKED_STATIONS,
    RECEIVE_MAP_SITUATIONS,
} from '../constants/InstallationsConstants'
import DtoInstallation from '../dto/DtoInstallation'
import DtoVariousMateriel from '../dto/DtoVariousMateriel'
import DtoVariousMatSituation from '../dto/DtoVariousMatSituation'
import DtoVariousMatType from '../dto/DtoVariousMatType'
import DtoInstallationGeo from '../dto/DtoInstallationGeo'
import DtoAssociatedStation from '../dto/DtoAssociatedStation'
import { FULL_RESET, RESET_AGRI } from '../../../../offline/constants/HomeConstants'
import DtoMapSituationResult from '../dto/DtoMapSituationResult'
import DtoMapSituation from '../dto/DtoMapSituation'

export const store = {
    installation: {},
    installations: [],
    variousMateriels: [],
    variousMatSituations: [],
    variousMatTypes: [],
    installationsWithGeo: [],
    mapSituations: [],
    mapSituationStation: [],
    mapSituationStationLast: [],
    linkedStations: [],
}

export function InstallationsReducer(state = {}, action) {
    switch (action.type) {
        case RECEIVE_ALL_INSTALLATIONS_GEO:
            return {
                ...state,
                installationsWithGeo: action.installationsWithGeo.map((i) => new DtoInstallationGeo(i)),
            }
        case RECEIVE_INSTALLATION:
            return {
                ...state,
                mapSituationStation: [],
                mapSituationStationLast: [],
                linkedStations: [],
                installation: new DtoInstallation(action.installation),
            }
        case RECEIVE_INSTALLATIONS:
            return {
                ...state,
                installations: action.installations.map((i) => new DtoInstallationGeo(i)),
            }
        case RECEIVE_ALL_VARIOUS_MATERIELS:
            return {
                ...state,
                variousMateriels: action.variousMateriels.map((m) => new DtoVariousMateriel(m)),
            }
        case RECEIVE_VARIOUS_MAT_SITUATIONS:
            return {
                ...state,
                variousMatSituations: action.variousMatSituations.map((s) => new DtoVariousMatSituation(s)),
            }
        case RECEIVE_VARIOUS_MAT_TYPES:
            return {
                ...state,
                variousMatTypes: action.variousMatTypes.map((s) => new DtoVariousMatType(s)),
            }
        case RESET_INSTALLATION:
            return {
                ...state,
                installation: {},
                mapSituationStation: [],
                mapSituationStationLast: [],
                linkedStations: [],
            }
        case RECEIVE_MAP_SITUATIONS:
            return {
                ...state,
                mapSituations: action.data.map(s => new DtoMapSituation(s)),
            }
        case RECEIVE_MAP_SITUATIONS_STATION:
            return {
                ...state,
                mapSituationStation: action.data.map(s => new DtoMapSituationResult(s)),
            }
        case RECEIVE_MAP_SITUATIONS_STATION_LAST:
            return {
                ...state,
                mapSituationStationLast: action.data.map(s => new DtoMapSituationResult(s)),
            }
        case RECEIVE_LINKED_STATIONS:
            return {
                ...state,
                linkedStations: action.data.map(s => new DtoAssociatedStation(s)),
            }
        case RESET_AGRI:
            return {
                ...store,
            }
        case FULL_RESET:
            return {
                ...store,
            }
        default:
            return state
    }
}
